import React, { useEffect } from 'react';
import FadeIn from '../ui/FadeIn';

const InquiryForm = () => {
  useEffect(() => {
    // Load Fillout Script once
    const existingScript = document.querySelector(`script[src="https://server.fillout.com/embed/v1/"]`);
    if (!existingScript) {
      const script = document.createElement('script');
      script.src = "https://server.fillout.com/embed/v1/";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <section id="inquire" className="py-16 md:py-32 px-5 md:px-6 bg-charcoal relative">
      <div className="max-w-4xl mx-auto">
        <FadeIn className="text-center mb-10 md:mb-16">
          <span className="font-script text-gold text-4xl block mb-4">Reservation Request</span>
          <h2 className="font-serif text-[32px] md:text-5xl text-ivory mb-6 leading-tight">Secure October 17</h2>
          <p className="text-stone font-serif italic text-lg md:text-xl max-w-2xl mx-auto leading-relaxed">
            Please complete the private inquiry below. Our estate concierge will contact you within 24 hours to discuss your celebration.
          </p>
        </FadeIn>

        <FadeIn delay={0.2}>
          <div className="relative overflow-hidden rounded-lg bg-[#0d0d0b] shadow-[0_20px_50px_rgba(0,0,0,0.5)] border border-gold/20">
            {/* Fillout Embed Container - Mobile Optimized Height */}
            <div 
              style={{ width: '100%' }} 
              className="w-full min-h-[800px] md:min-h-[650px]"
              data-fillout-id="md6mZ4ZqVsus" 
              data-fillout-embed-type="standard" 
              data-fillout-inherit-parameters 
              data-fillout-dynamic-resize
            ></div>
            
            {/* Decorative Corner Accents */}
            <div className="absolute top-0 left-0 w-12 h-12 border-t border-l border-gold/30 pointer-events-none"></div>
            <div className="absolute bottom-0 right-0 w-12 h-12 border-b border-r border-gold/30 pointer-events-none"></div>
          </div>
          
          <div className="mt-10 text-center">
            <div className="flex items-center justify-center gap-4 opacity-40">
              <div className="w-8 h-px bg-gold"></div>
              <p className="text-stone text-[10px] tracking-[0.3em] uppercase">Private Estate Tour Included</p>
              <div className="w-8 h-px bg-gold"></div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>
  );
};

export default InquiryForm;